 
function renderPivotTable(data, pivotParams) {
  setupRenderers();
   pivotParams.sorters= {
      "Dia de la semana": $.pivotUtilities.sortAs(
              ["LUNES", "MARTES",
              "MIERCOLES", "JUEVES",
              "VIERNES", "SABADO", "DOMINGO"])
      ,"Mes": $.pivotUtilities.sortAs(
                ["ENERO", "FEBRERO",
                "MARZO", "ABRIL",
                "MAYO", "JUNIO", "JULIO",
                "AGOSTO", "SEPTIEMBRE",
                "OCTUBRE", "NOVIEMBRE",
                "DICIEMBRE"]) 

      };

  pivotParams.renderers = $.extend(
    $.pivotUtilities.renderers, 
    $.pivotUtilities.plotly_renderers
  )
  $("#output").pivotUI(data, pivotParams);
};